import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const offBoardingWithdrawnSlice = createSlice({
  name: "offBoardingWithdrawn",

  initialState: { offBoardingWithdrawn: {} },
  reducers: {
    setOffBoardingWithdrawn: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.offBoardingWithdrawn = payload;
    },
    resetOffBoardingWithdrawn: (state) => {
      state.offBoardingWithdrawn = {};
    },
  },
});

export const { setOffBoardingWithdrawn, resetOffBoardingWithdrawn } =
  offBoardingWithdrawnSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default offBoardingWithdrawnSlice.reducer;
